import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFreightGroupItemCompareChangeItem extends Layout {
	sourceEdiCompareItem: DataSource;
	tableFreightGroupItemChangeItems: Table;
}
